import {
	Dialog,
	DialogClose,
	DialogContent,
	DialogTitle,
} from "@commerce-frontend/ui/components/Dialog/Dialog";
import { useTranslations } from "next-intl";
import { useEffect, useState } from "react";
import { QuickSearchMobile } from "../QuickSearch/QuickSearchMobile";
import type { SearchBarProps } from "../SearchBar/SearchBar";
import { SearchBar } from "../SearchBar/SearchBar";

type MobileSearchModalProps = {
	open: boolean;
	onOpenChange: (open: boolean) => void;
} & SearchBarProps;

export const MobileSearchModal = ({
	locale,
	value,
	showQuickSearch,
	recentSearchTerms,
	searchResult,
	open,
	loadingSearchResults,
	onOpenChange,
	onInputValueChange,
	onSelectLink,
	onSelectProductLink,
	onClickDeleteLink,
	onClickSubmitLink,
	onClickCloseButton,
	onFocusInput,
	onBlurInput,
}: MobileSearchModalProps) => {
	const t = useTranslations("MobileSearchModal");

	const [isClient, setIsClient] = useState(false);

	useEffect(() => {
		setIsClient(true);
	}, []);

	if (!isClient) {
		return null;
	}

	return (
		<Dialog
			closeOnInteractOutside={false}
			open={open}
			onOpenChange={onOpenChange}
		>
			<DialogContent
				side="center"
				className="min-h-dvh w-full flex-col overflow-hidden rounded-none bg-white max-sm:inset-y-0 max-sm:gap-0"
			>
				{open && (
					<>
						<DialogTitle
							data-testid="mobile-search-modal"
							className="flex flex-row items-center justify-center gap-4 bg-main p-4 text-white"
						>
							<SearchBar
								locale={locale}
								value={value}
								showQuickSearch={showQuickSearch}
								recentSearchTerms={recentSearchTerms}
								searchResult={searchResult}
								loadingSearchResults={loadingSearchResults}
								onInputValueChange={onInputValueChange}
								onSelectLink={onSelectLink}
								onSelectProductLink={onSelectProductLink}
								onClickDeleteLink={onClickDeleteLink}
								onClickSubmitLink={onClickSubmitLink}
								onClickCloseButton={onClickCloseButton}
								onFocusInput={onFocusInput}
								onBlurInput={onBlurInput}
							/>
							<DialogClose className="text-sm md:text-base">
								{t("cancel")}
							</DialogClose>
						</DialogTitle>
						<div className="overflow-y-auto">
							<QuickSearchMobile
								locale={locale}
								value={value}
								searchResult={searchResult}
								recentSearchTerms={recentSearchTerms}
								onSelectLink={onSelectLink}
								onSelectProductLink={onSelectProductLink}
								onClickDeleteLink={onClickDeleteLink}
							/>
						</div>
					</>
				)}
			</DialogContent>
		</Dialog>
	);
};
